import { Link, useLocation } from "react-router-dom";
import { ChevronDown, Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { images } from "../data";

const productLinks = [
  { label: "Technical Textiles", to: "/products#technical-textiles" },
  { label: "Flexible Packaging", to: "/products#flexible-packaging" },
  { label: "Rigid Packaging", to: "/products#rigid-packaging" },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const location = useLocation();
  useEffect(() => { setMenuOpen(false); setProductsOpen(false); }, [location.pathname, location.hash]);

  return (
    <header className="site-header">
      <div className="container header-inner">
        <Link to="/" className="brand" data-testid="nav-logo" aria-label="SGN Agrotech home"><img src={images.logo} className="brand-logo" alt="SGN Agrotech LLP" /></Link>
        <nav className="desktop-nav" aria-label="Main navigation">
          <Link to="/about" data-testid="nav-link-about">About</Link>
          <div className="nav-dropdown">
            <button type="button" data-testid="nav-products-toggle" onClick={() => setProductsOpen(!productsOpen)} aria-expanded={productsOpen}>Products <ChevronDown size={14} /></button>
            {productsOpen && <div className="product-menu" data-testid="nav-products-menu">{productLinks.map((link) => <Link key={link.to} to={link.to} data-testid={`nav-product-${link.label.toLowerCase().replace(/ /g, "-")}`}>{link.label}</Link>)}<Link to="/products" className="menu-all" data-testid="nav-products-all">View all products <span>↗</span></Link></div>}
          </div>
          <Link to="/manufacturing" data-testid="nav-link-manufacturing">Manufacturing</Link>
          <Link to="/industries" data-testid="nav-link-industries">Industries</Link>
          <Link to="/contact" data-testid="nav-link-contact">Contact</Link>
        </nav>
        <div className="header-actions"><Link to="/contact" className="button button-small button-orange" data-testid="nav-cta-rfq">Start a conversation <span>↗</span></Link></div>
        <button className="menu-toggle" type="button" onClick={() => setMenuOpen(!menuOpen)} aria-label={menuOpen ? "Close menu" : "Open menu"} data-testid="nav-mobile-toggle">{menuOpen ? <X size={22} /> : <Menu size={22} />}</button>
      </div>
      {menuOpen && <div className="mobile-menu" data-testid="nav-mobile-menu"><div className="container mobile-menu-inner"><Link to="/about" data-testid="mobile-nav-about">About</Link><Link to="/products" data-testid="mobile-nav-products">Products <span>↗</span></Link><Link to="/manufacturing" data-testid="mobile-nav-manufacturing">Manufacturing</Link><Link to="/industries" data-testid="mobile-nav-industries">Industries</Link><Link to="/contact" data-testid="mobile-nav-contact">Contact</Link><Link to="/contact" className="button button-orange" data-testid="mobile-nav-cta">Request a technical brief <span>↗</span></Link></div></div>}
    </header>
  );
}
